module.exports = __webpack_public_path__ + "img/trinapp-future.bfa628b2.png";